module.exports = __webpack_public_path__ + "static/media/usBanner.ddf6ed3d.webp";